import _get from 'lodash/get';
import Cookie from 'cookie';

interface Options {
  onChange: (data: {
    pixel_id?: string,
    browser_id?: string,
    click_id?: string,
    external_id?: string,
  }) => void;
}

export function collectParams({ onChange }: Options): Promise<void> {
  return new Promise((resolve) => {
    const f = () => {
      const cookie = Cookie.parse(document.cookie);

      const browser_id = cookie._fbp || undefined;
      const click_id = cookie._fbc || undefined;

      const pixelsByID = _get(window, 'fbq.instance.pixelsByID', false);
      const pixel_id = pixelsByID && typeof pixelsByID === 'object' && Object.keys(pixelsByID).length ? Object.keys(pixelsByID)[0] : '';
      const external_id = _get(pixelsByID, [pixel_id, 'userData', 'external_id']);

      if (pixel_id && browser_id) {
        onChange({
          pixel_id,
          browser_id,
          click_id,
          external_id,
        });
        resolve();
      } else {
        setTimeout(f, 50);
      }
    };
    f();
  });
}
